<app-header-navigation-bar></app-header-navigation-bar>

<div class="insurances-page">

    <app-page-header title="Mis seguros" subtitle="Consulta las coberturas y el contrato de tus seguros"></app-page-header>

    <main class="insurances-main">

        <section class="insurances-section">

            <div class="insurances-list" *ngIf="insurances.length > 0">
                <article class="insurance-card" *ngFor="let card of insurances; let i = index; trackBy: trackByIndex">
                    <div class="card-body">
                        <div class="card-icon" aria-hidden="true">
                            <img class="card-icon-img" [src]="iconForCard(card)" alt="">
                        </div>

                        <div class="card-info">
                            <div class="card-head">
                                <h3 class="card-title">{{ card.nombre }}</h3>
                                <span class="card-state">{{ card.estado }}</span>
                            </div>

                            <p class="card-line" *ngIf="card.polizaNumero">
                                <span>Nº de póliza </span>
                                <strong>{{ card.polizaNumero }}</strong>
                            </p>
                            <p class="card-line" *ngIf="card.vigencia">
                                <span>Vigencia </span>
                                <strong>{{ card.vigencia }}</strong>
                            </p>
                            <p class="card-line" *ngIf="!card.vigencia && card.renovacionAutomatica">
                                <span>Renovación automática </span>
                                <strong>{{ card.renovacionAutomatica }}</strong>
                            </p>
                        </div>
                    </div>

                    <div class="card-actions">
                        <app-actions-dropdown [items]="card.acciones"></app-actions-dropdown>
                    </div>
                </article>
            </div>

            <div class="empty-state" *ngIf="!loading && insurances.length === 0">
                <p>No tienes seguros activos.</p>
            </div>

            <div class="loading-state" *ngIf="loading && insurances.length === 0">
                <p>Cargando seguros<span>.</span><span>.</span><span>.</span></p>
            </div>
        </section>

    </main>

</div>

<app-footer></app-footer>
